import { render } from "./SideBar2.vue?vue&type=template&id=1a577f80&scoped=true"
import script from "./SideBar2.vue?vue&type=script&lang=js"
export * from "./SideBar2.vue?vue&type=script&lang=js"

import "./SideBar2.vue?vue&type=style&index=0&id=1a577f80&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a577f80"]])

export default __exports__